import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
// Reducer Thunk
export const getAOP = createAsyncThunk('AOP/getAOP', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/AOP`, loadData)
        if (response.data.success) {
            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})
export const getAOPTotal = createAsyncThunk('AOP/getAOPTotal', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/AOP`, loadData)
        if (response.data.success) {
            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})
const AOPSlice = createSlice({
    name: 'AOP',
    initialState: {
        allPageLoad: [],
        AOPTotal: [],
        Loading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getAOP.pending, (state, action) => {
            console.log('Fetching todos from backend ....')
            state.Loading = true
        })
        builder.addCase(getAOP.fulfilled, (state, action) => {
            console.log('Done')
            state.allPageLoad = action.payload
            state.Loading = false
        })
        builder.addCase(getAOP.rejected, (state, action) => {
            console.log('Failed to get todos!!!')
            state.Loading = false
        })
        builder.addCase(getAOPTotal.fulfilled, (state, action) => {
            console.log('Done')
            state.AOPTotal = action.payload
            state.Loading = false
        })
    }
})

// Reducer
const AOPReducer = AOPSlice.reducer

// Selector
export const AOPSelector = (state) => state.AOPReducer
// Action export
export const {
} = AOPSlice.actions

// Export reducer
export default AOPReducer